export default __webpack_public_path__ + "static/media/miscellanous-active.913ecd7a.svg";